import {apiDateToForm, formDateToApi} from '../helpers/dateHelper';

const transform = link => ({ ...link, date: apiDateToForm(link.date) });

const reverseTransform = link => ({ ...link, date: formDateToApi(link.date) });

export { transform, reverseTransform };
